var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",attrs:{"id":"mainWrapper"}},[(_vm.showLoading)?_c('Loading'):_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.fullPath}),(!_vm.isNotFound)?_c('ShowNotifications'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }